// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-V":"V_dpu-detail-V__Nz5L9"};